import { ChannelPayloadFilter, ViewStream } from "spyne";

export class ExternalLinksLauncher extends ViewStream {
  constructor(props = {}) {
    super(props);
  }

  addActionListeners() {
    // return nexted array(s)
    const eventTypePayloadFilter = new ChannelPayloadFilter({
      payload: (p) => p.eventType === "externalLink",
    });

    return [
      ["CHANNEL_UI_CLICK_EVENT", "onExternalLinkClick", eventTypePayloadFilter],
    ];
  }

  onExternalLinkClick(e) {
    const { payload } = e;
    const { link } = payload;

    try {
      window.open(link);
    } catch (e) {
      console.warn("EXTERNAL LINK ISSUE ", e);
    }

    //console.log("EXTERNAL LINK ",{link, payload});
  }

  broadcastEvents() {
    // return nexted array(s)
    return [];
  }

  onRendered() {
    //this.addChannel("CHANNEL_UI");
  }
}
